<template>
    <div class="pt-2">
        <router-view></router-view>
    </div>
   
</template>
<script>
    import contractTable from './table';
    export default {
        components: {
            contractTable,
        },
    }
</script>
<style scoped lang="scss">

.new_term{
    border: 1px solid  rgb(72, 166, 166) !important;
    background: rgb(72, 166, 166) ;
    color: white;
    &:hover {
    background-color: #f0ed00;
    color: rgb(72, 166, 166) !important;
    background: white !important;

    }
  }
</style>